import React, {useState} from 'react'
import { useHistory } from 'react-router';
import {login, checkIsSetupComplete} from "utils";

import {
    Page,
    Container
} from "./Login.styles";
import {StyledButton} from "../../../components/Buttons/DefaultButton/DefaultButton.styles";
import {FormMaterialInput} from "../../../components/Inputs/MaterialInput";
import SignUpHeader from "../../../components/SignUpHeader";
import * as ls from "local-storage";
import Api from "../../../api";
import HeaderStatusBar from "../../../components/HeaderStatusBar";
import {useForm} from "react-hook-form";
import {joiResolver} from "@hookform/resolvers/joi";
import joi from "joi";
import {usePersistedState} from "../../../hooks";
import entities from "../../../reduxStore/entityKeys";
import {HYGIENIST_TYPES} from "utils/types";
import useQueryParams from 'hooks/useQueryParams';

// @ts-ignore
const TempStars = window.TempStars;
// @ts-ignore
const app = window.app as any;
// @ts-ignore
const mainView = window.mainView as any;

const schema = joi
    .object({
        email: joi.string().email({ tlds: { allow: false } }).label('Login').required(),
        password: joi.string().label('Password').required(),
    }).required()

export default function Login() {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState<string>('');
    ls.remove('pageData');

    const { payInvoice, jobPost } = useQueryParams();

    const setUser = usePersistedState({
        entityName: entities.user,
    })[1];

    const goNext = () => {
        history.push({
            pathname: 'RoleSelect'
        });
    }

    const goForgotPassword = () => {
        history.push({
            pathname: 'ForgotPassword'
        });
    }

    const {
        control,
        handleSubmit,
        setError,
    } = useForm({
        resolver: joiResolver(schema) as any,
    });

    const onSubmit = async (event: any) => {
        const {email, password} = event

        try {
            app.showPreloader('Logging In');
            const userProps = await login( email, password, setUser );
            const isSetupComplete = checkIsSetupComplete(userProps)
            if (isSetupComplete) {
                await TempStars.App.gotoStartingPage1();

                /* Query params redirection check */
                if (payInvoice != "") {
                    app.hidePreloader();
                    return;
                }
                if (jobPost != "") {
                    app.hidePreloader();
                    return;
                }

                if (userProps.hygienistId &&
                    (userProps.hygienist?.type === HYGIENIST_TYPES.FRONT_DESK
                        || userProps.hygienist?.type === HYGIENIST_TYPES.ASSOCIATE_DENTIST)) {
                    TempStars.Analytics.track('log in')
                    history.push({
                        pathname: 'jobPostsList'
                    })
                } else {
                    history.push('loading')
                }
            } else {
                const { roleId } = await Api.getRole();
                app.hidePreloader();
                let pathname = roleId === 4
                    ? 'SignUp1_DO'
                    : 'SignUp1_Talent'
                if (!!userProps?.hygienistId && !!userProps?.hygienist?.firstName) {
                    pathname = 'SignUp2_Talent'
                }
                history.push({
                    pathname: pathname,
                })
            }
            app.hidePreloader();
        } catch (e: any) {
            TempStars.Analytics.track('login - error')
            app.hidePreloader();
            console.error(e)
            setError("email", {type: "manual", message: "Username or password is incorrect"})
            setError("password", {type: "manual", message: "Username or password is incorrect"})
            return setErrorMessage(`${e.message? e.message.replace(/['"]+/g, '') : "Username or password is incorrect"}`);
        }
    }

    return (
        <Page>
            <Container data-page="login" className={'no-swipeback'}>
                <HeaderStatusBar />

                <div className={"loginForm"}>
                    <SignUpHeader
                        title= {'Login'}
                        error={errorMessage}
                    />

                    <div className="contentBlock">
                        <form id="login-form" onSubmit={handleSubmit(onSubmit)}>
                            <FormMaterialInput
                                className={'inset'}
                                control={control}
                                name={'email'}
                                label={'Login'}
                                type="email"
                            />
                            <FormMaterialInput
                                className={'inset'}
                                control={control}
                                name={'password'}
                                label={'Password'}
                                type={'password'}
                            />
                            <StyledButton
                                variant="contained"
                                color="primary"
                                size="large"
                                id="signup-button"
                                type={'submit'}
                            >
                                Login
                            </StyledButton>
                        </form>
                    </div>

                    <div className="dont-have-an-account-sign-up-wrapper">
                        <div className="dont-have-an-container">
                            <span>Don't have an account? </span>
                            <div className="underlinedLink" onClick={goNext}>Sign Up</div>
                        </div>
                    </div>

                    <div className="terms-of-service-privacy-pol-wrapper">
                        <div className="terms-of-service-container">
                            <a className="underlinedLink external externalLink"
                               href="https://www.tempstars.ca/terms"
                               target="_system"
                            >
                                Terms of Service
                            </a>
                            <span className="span1"> & </span>
                            <a className="underlinedLink external externalLink"
                               href="https://www.tempstars.ca/privacy"
                               target="_system"
                            >
                                Privacy Policy
                            </a>
                        </div>
                    </div>

                    <div className="forgotten-password-parent">
                        <div className="underlinedLink" onClick={goForgotPassword}>Forgot Password?</div>
                    </div>

                </div>

                <div className="footer footerLinks"></div>
            </Container>
        </Page>
    )
}
